module.exports = __webpack_public_path__ + "static/media/got-hidden-power.fb087839.mp3";